module.exports = __webpack_public_path__ + "static/media/iphone_13_pro_sierra_blue.df3a78ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_pro_sierra_blue.png
// module id = 2168
// module chunks = 0